import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { TenantService } from '.';
import { Observable, forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { UserService } from './user.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TrialExpiredAdminGuard implements CanActivate {

    constructor(private tenantService: TenantService,
                private userService: UserService, 
                private router:Router) {}

    canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return forkJoin([
            this.tenantService.getUnauthTenantInfo().pipe(map(tenant => ['TRIAL_EXPIRED', 'UNPAID'].includes(tenant.status))),
            this.userService.isLoggedIn().pipe(map(status => status.user && _.find(status.user.tenantRoles, { roleType: 'TENANT_ADMIN' }) ? true : false))
        ])
        .pipe(map(([isTrialExpired, isAdmin]) => !isAdmin || !isTrialExpired || this.router.createUrlTree(['/settings/subscriptionPlan'])));
    }
}
